import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlaySetEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlaySetEventVO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly value: RoomBrandOverlaySetEvent) {
    JsonSchemaValidator.assert(RoomBrandOverlaySetEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlaySetEvent {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
